<template>
  <div
    class="editorHtml"
    v-loading="loading"
    element-loading-text="编辑器拼命加载中..."
  >
    <div
      class="split-mark"
      v-if="editablePaper"
    ></div>

    <div class="paper-html-box">
      <div
        id="tinymceBar"
        class="tinymce-tool-bar"
        :class="editablePaper ? 'tinymce-tool-bar-fix' : ''"
      ></div>
      <template v-if="editablePaper">
        <div
          class="bg-btn cancle-btn"
          @click="doClose"
        >
          取消
        </div>
        <div
          class="bg-btn save-btn"
          @click="doSave"
        >
          保存
        </div>
        <div class="editor-tag-list" @click="addTag">
          <h1><img src="../images/edit_base.png">基础标记</h1>
          <span data-tag="题型">【题型】</span>
          <span data-tag="题干">【题干】</span>
          <span data-tag="选项">【选项】</span>
          <span data-tag="答案">【答案】</span>
          <span data-tag="解析">【解析】</span>
          <hr>
          <h1><img src="../images/edit_zuti.png">组题标记</h1>
          <span data-tag="大题题型">【大题题型】</span>
          <span data-tag="大题题干">【大题题干】</span>
          <span data-tag="大题解析">【大题解析】</span>
          <span data-tag="小题题型">【小题题型】</span>
          <span data-tag="小题题干">【小题题干】</span>
          <span data-tag="小题选项">【小题选项】</span>
          <span data-tag="小题答案">【小题答案】</span>
          <span data-tag="小题解析">【小题解析】</span>
          <hr>
          <h1><img src="../images/edit_zuti.png">其他工具</h1>
          <span data-tag="insert">插选项</span>
          <span data-tag="试卷答案">【试卷答案】</span>
          <span data-tag="rule" class="rule-btn"><i class="el-icon-warning"></i>标记规范</span>
        </div>
      </template>

      <!-- <div
        v-if="isScroll"
        class="scroll-box"
        v-scrollbar="'edit-main'"
      > -->
     <div
        v-if="isScroll"
        class="scroll-box"
      >
        <div
          class="edit-main"
          :id="id"
          :contenteditable="editablePaper"
          @mousedown="startDivide"
          @mouseup="endDivide"
          @mouseleave="leaveDivide"
          v-html="paperHtml"
        ></div>
      </div>
      <div
        v-else
        class="no-scroll-box"
      >
        <div
          class="edit-main"
          :id="id"
          :contenteditable="editablePaper"
          @mousedown="startDivide"
          @mouseup="endDivide"
          @mouseleave="leaveDivide"
          v-html="paperHtml"
        ></div>
      </div>
    </div>
    <setOptionNum
      v-model="dialogVisible"
      @setOption="submitInsert"
    >
    </setOptionNum>
  </div>
</template>

<script>
// TinyMCE 中文文档：http://tinymce.ax-z.cn
import { getItem, mathmlToImg } from "@/utils/tools";
import addDot from "@/components/editor4/tinymce/plugins/addDot";
import addWave from "@/components/editor4/tinymce/plugins/addWave";
import indent2em from "@/components/editor4/tinymce/plugins/indent2em";
// import hwOssMixins from "@/mixins/hwOssMixins";
import setOptionNum from './setOptionNum'

import { Base64 } from "js-base64";
var tinymce = window.tinymce;

export default {
  name: "editorHtml",
  // mixins: [hwOssMixins],
  components: {
    setOptionNum
  },
  props: {
    id: {
      default: () => "tinymce",
      required: false,
      type: String,
    },
    value: {
      default: () => "",
      required: false,
      type: String,
    },
    noAccept: {
      default: "image/svg+xml",
      type: String,
    },
    accept: {
      // 文件类型
      default: "image/jpeg, image/png",
      type: String,
    },
    maxSize: {
      // 大小
      default: 1024 * 1024 * 2,
      type: Number,
    },
    editablePaper: {
      type: Boolean,
      default: false,
    },
    isScroll: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      bucket: 'jty-open-new',
      loading: false,
      paperHtml: "",
      isInit: true,
      noEdit: false,
      mouseDownPositionX: 0,
      mouseDownPositionY: 0,
      dialogVisible: false
    };
  },
  mounted() {
    tinymce = window.tinymce;
    this.paperHtml = this.dealQuestionIn(this.value) || "";
    this.bindEvent()
  },
  watch: {
    editablePaper: {
      handler(newVal) {
        this.noEdit = false
        if (newVal) {
          this.paperHtml = this.dealQuestionIn(this.value) || "";
        }
      },
    },
    value(newVal, oldVal) {
      if (this.noEdit) {
        return;
      }
      this.paperHtml = this.dealQuestionIn(this.value) || "";
      if (!this.editablePaper) {
        this.isInit = true
      }
    }
  },
  methods: {
    getElementIndex(elem) {
      var parent = elem.parentElement;
      var children = parent.children;
      var index = 0;
      for (var i = 0; i < children.length; i++) {
        if (children[i].classList.contains('qArea')) {
          if (children[i] === elem) {
              return index;
          }
          index++; // 只增加计数当元素符合类名条件
        }
      }
      return -1; // 如果没有找到，返回-1
    },
    bindEvent() {
        let _this = this;
        document.getElementById('splitHtmlEditor').addEventListener('click', function(event) {
            let className = event.target.className
            if (className.indexOf('qArea') === -1) {
                return;
            }

            const bounds = this.getBoundingClientRect();
            const x = bounds.right - event.clientX; // 获取相对于元素左边界的X坐标
            let index = _this.getElementIndex(event.target)
            if (x < 100) {
              if (index > -1) {
                console.log('取消划题');
                _this.$emit('cancle', +index)
              }
            } else {
              _this.$emit('preview', +index)
            }
        })
    },
    addTag(e) {
      let tag = e.target.getAttribute('data-tag')
      if (!tag) {
        return;
      }
      if (tag === 'rule') {
        this.$emit('showRule')
        return;
      }
      if (tag === 'insert') {
        this.dialogVisible = true
        return;
      }
      let tagText = `<mark>【${tag}】</mark>`
      this.insertTextAtCursor(tagText)
    },
    submitInsert(obj) {
      let {
        start,
        end,
        num
      } = obj
      let numText = Array.from({length: num}, (_, i) => {
        const letter = String.fromCharCode(65 + i); // ASCII码转换
        return `${letter}.${letter}`;
      }).join('<span style="width: 30.99pt; display: inline-block; -aw-tabstop-align: left; -aw-tabstop-pos: 103.9pt;">&nbsp;</span>');
      let tagText = ''
      for(let i = start; i <= end; i++) {
        tagText += `<p>${i}．${numText}</p>`
      }
      console.log(tagText);
      this.dialogVisible = false
      this.insertTextAtCursor(tagText)
    },
    // 内容传入富文本的时候做些处理操作（拆解的时候标签不齐）, 第一次加载内容的处理和编辑时候的处理不一样
    dealQuestionIn(val) {
      if (val) {
        // 替换图片链接
        let newimgsrc =
          'src="http://jty-xbzyk.obs.cn-north-4.myhuaweicloud.com/';
        let reg = new RegExp('src="/', "g");
        let newoptions = val.replace(reg, newimgsrc);
        newoptions = newoptions.replace(/http:\/\/jty/g, "https://jty");
        // 去掉alt
        let altReg = /alt="[^<>]*?"/g;
        newoptions = newoptions.replace(altReg, "");
        // 去掉空行
        newoptions = newoptions.replace(/^<p[^<>]*?><\/span><\/p>/g, "");
        // 去掉颜色
        newoptions = newoptions.replace(/color:/g, "colorFc:");
        // img的name转mml + latex
        newoptions = newoptions.replace(
          /(<img[^<>]*?)(name[\s=]*?".*?")([^<>]*?)(nickName[\s=]*?".*?")([^<>]*?>)/g,
          ($0, $1, $2, $3, $4, $5) => {
            let match1 = $2.match(/name="([^"]+)"/);
            let name1 = match1 ? match1[1] : null;
            let mml = "";
            if (name1) {
              mml = Base64.decode(name1);
            }
            let match2 = $4.match(/nickName="([^"]+)"/);
            let name2 = match2 ? match2[1] : null;
            let tex = "";
            if (name2) {
              tex = name2;
            }
            return (
              $1 +
              ' class="Wirisformula" data-mathml="' +
              mathmlToImg(mml) +
              '"' +
              $3 +
              ' data-latex="' +
              tex +
              '"' +
              $5
            );
          }
        );
        newoptions = newoptions.replace(
          /<dot>(.*?)<\/dot>/g,
          "<bdo class='dot'>$1</bdo>"
        );
        newoptions = newoptions.replace(
          /<wave>(.*?)<\/wave>/g,
          "<bdo class='wave'>$1</bdo>"
        );
        return newoptions;
      } else {
        return val;
      }
    },
    insertTextAtCursor(text) {
        const editor = tinymce.activeEditor;
        if (!editor || editor.id !== "splitHtmlEditor") {
          alert('请先点击编辑器，使其获得焦点！');
          return;
        }
        editor.focus()
        editor.selection.setContent(text + editor.selection.getContent());
    },
    mountedInit() {
      if (!this.isInit) {
        return;
      }
      const _this = this;
      _this.loading = true;
      return new Promise((resolve, reject) => {
        addDot(tinymce);
        addWave(tinymce);
        indent2em(tinymce);
        const initData = Object.assign({
          selector: "#" + this.id, // 指定初始化Tinymce的元素
          inline: true, // 开始内联模式
          fixed_toolbar_container: "#tinymceBar",
          content_css: "/static/tinymce/skins/custom-conent.css", // 自定义编辑区域内的样式
          language_url: "/static/tinymce/zh_CN.js", // 变更语言，语言文件必须是网站的绝对路径
          language: "zh_CN", // 设置中文
          indentVal: "2em", // 配置首行缩进
          paste_enable_default_filters: false, // 是否开启默认过滤器(开启后会对粘贴内容进行过滤)
          autoresize_min_height: 150,
          forced_root_block: "p",
          // forced_root_block_attrs: {
          //   style: "vertical-align: middle;",
          // },
          force_p_newlines: true,
          force_br_newlines: false,
          formats: {
            // 自定义格式清除
            removeformat: [
              {
                selector:
                  "b,strong,em,i,font,u,strike,dfn,code,samp,kbd,var,cite,mark,q,del,ins",
                remove: "all",
                // split: true,
                expand: false,
                block_expand: true,
                deep: true,
              },
              {
                selector: "p,span",
                attributes: ["style", "class"],
                remove: "none",
                // split: true,
                expand: false,
                deep: true,
              },
            ],
          },
          skin_url: "/static/tinymce/skins/lightgray", // 设置皮肤，皮肤用于更改编辑器的外观，例如颜色、边距、填充、字体、图标等
          plugins: [
            "code",
            "indent2em",
            "addDot",
            "addWave",
            "table",
            "paste",
            "image",
            "charmap",
            "fullscreen",
            "preview",
            "textcolor",
            "contextmenu",
            "autoresize",
          ],
          toolbar:
            "bold italic underline subscript superscript removeformat image tiny_mce_wiris_formulaEditor tiny_mce_wiris_formulaEditorChemistry table charmap alignleft aligncenter alignright fontsizeselect fontselect indent2em addDot addWave undo redo",
          fontsize_formats: "8px 10px 12px 14px 18px 24px 36px",
          font_formats:
            "宋体=宋体;楷体=楷体;微软雅黑=微软雅黑;Times New Romance=Times New Romance;Microsoft YaHei=Microsoft YaHei;Arial=arial,sans-serif;",
          menubar: false, // 是否显示开启菜单栏
          contextmenu: "cut copy paste indent2em addDot addWave", // 右键菜单工具
          image_advtab: true, // 允许为图片添加自定义样式、边距、边框
          paste_data_images: true, // 粘贴的同时能把内容里的图片自动上传
          paste_merge_formats: true, // 启用粘贴插件合并格式功能
          statusbar: false, // 是否显示底部状态栏（显示字数）
          images_reuse_filename: true, // 上传后使用图片真实文件名称
          automatic_uploads: true, // 启用或者禁止自动上传由 data URL 或者 blob URls表示的图像，关闭后，直接拖放在编辑区域的图片不会上传到CDN，而是以Base:64格式保存在后台数据库中
          extended_valid_elements:
            "maction[actiontype|class|id|style|style|mathbackground|mathcolor|selection],math[xmlns|class|id|style|dir|href|mathbackground|mathcolor|display|mode|overflow],menclose[class|id|style|href|mathbackground|mathcolor|notation],merror[class|id|style|href|mathbackground|mathcolor],mstyle,mglyph[src|alt],ms[lquote|rquote],mspace[width],mfrac[bevelled|class|id|style|denomalign|href|linethickness|mathbackground|mathcolor|numalign],mglyph[valign|width|src|mathbackground|href|height|class|id|style|alt],msqrt,msup,mfenced[class|id|style|href|mathbackground|mathcolor|close|open|separators],mrow,mtable[columnalign|side],mtr,mtd,mn,mo,mi[class|id|style|dir|href|mathbackground|mathcolor|mathvariant|mathsize],mlabeledtr,mmultiscripts,mover[accent],mpadded,mphantom,mroot,msub,msubsup[mathbackground|mathcolor|subscriptshift|superscriptshift],munder[accent],munderover,semantics[definitionURL|encoding|cd|name|src],mtext",
          external_plugins: {
            tiny_mce_wiris: "/static/tiny_mce_wiris/plugin.min.js",
          },
          // 初始化回调
          init_instance_callback(editor) {},
          // 图片上传
          images_upload_handler(blobInfo, success, failure) {
            let localFile = blobInfo.blob();
            if (localFile.size > _this.maxSize) {
              failure("文件体积过大");
              return;
            }
            if (_this.noAccept.indexOf(localFile.type) >= 0) {
              console.log("svg不操作");
              return;
            }
            if (_this.accept.indexOf(localFile.type) === -1) {
              failure("图片格式错误");
              return;
            }
            if (!(localFile instanceof window.File)) {
              let reader = new FileReader();
              reader.onload = () => {
                let temp = reader.result;
                localFile = new File([temp], localFile.name, {
                  type: localFile.type,
                  lastModified: localFile.lastModified,
                  size: localFile.size,
                });
                _this.uploadPic(localFile, success, failure);
              };
              reader.readAsArrayBuffer(localFile);
            } else {
              _this.uploadPic(localFile, success, failure);
            }
          },
          paste_postprocess: function (plugin, args) {
            // 去掉字体和大小
            // _this.dealNode(args.node);
            // 去掉外面包裹的第一个p标签
            if (
              /<p[^<>]*?class=\"MsoNormal\"[^<>]*?>(.*?)<\/p>/.test(
                args.node.innerHTML
              )
            ) {
              args.node.innerHTML = args.node.innerHTML.replace(
                /<p[^<>]*?class=\"MsoNormal\"[^<>]*?>(.*?)<\/p>/,
                "$1"
              );
            }
            if (/vertical-align:\s*(sub|supper)/.test(args.node.innerHTML)) {
              args.node.innerHTML =  args.node.innerHTML + '<span>&nbsp;</span>'
            }
            args.node.innerHTML = args.node.innerHTML.replace(/&nbsp;/ig, " ");
            args.node.setAttribute("id", "42");
          },
          // 双向绑定，编辑器检测到有变化时调用 $emit(‘input’, value) 将数据写出到父组件
          setup: function (editor) {
            // 不要绑定change事件,value赋值变化的时候会先触发change，watch后触发，导致出问题
            editor.on("change", function (e) {
              if (_this.editablePaper) {
                _this.noEdit = true
              }
            });
            editor.on("input undo redo execCommand KeyUp", function (e) {
              if (_this.editablePaper) {
                _this.noEdit = true
              }
              let newoptions = editor.getContent();
              let wirisReg =
                /<(img[^<>]*?class="Wirisformula"[^<>]*?)(style="[^<>]*?")([^<>]*?)>/g;
              let wirisStyle =
                '<$1style="vertical-align: middle; -aw-left-pos: 0pt; -aw-rel-hpos: column; -aw-rel-vpos: paragraph; -aw-top-pos: 0pt; -aw-wrap-type: inline;"$3>';
              newoptions = newoptions.replace(wirisReg, wirisStyle);
              newoptions = newoptions.replace(
                /<bdo class="dot">(.*?)<\/bdo>/g,
                "<dot>$1</dot>"
              );
              newoptions = newoptions.replace(
                /<bdo class="wave">(.*?)<\/bdo>/g,
                "<wave>$1</wave>"
              );
              _this.$emit("input", newoptions);
            });
            editor.on("focus", function (e) {
              _this.$emit("input", editor.getContent());
            });
            editor.on("blur", function (e) {
              _this.noEdit = false
            });
          },
        });
        tinymce.init(initData).then(() => {
          this.isInit = false;
          _this.loading = false;
        });
      });
    },
    uploadPic(localFile, success, failure) {
      // 走oss前端上传
      // this.doUpload({
      //   file: localFile,
      //   onProgress: () => {},
      // })
      //   .then((res) => {
      //     if (!res.url) {
      //       failure("上传失败: error");
      //       return;
      //     }
      //     // 使用CND地址替换<image>标签的src属性，调用success方法并传入图片地址
      //     const imgURL = res.url.replace("http:", "https:");
      //     success(imgURL);
      //     this.$emit("input", tinymce.get(this.id).getContent());
      //     setTimeout(() => {
      //       tinymce.get(this.id).focus();
      //     }, 100);
      //   })
      //   .catch(() => {
      //     failure("上传失败: error");
      //   });
    },
    dealNode(node) {
      let nodeType = node.nodeType;
      if (nodeType === 1) {
        node.face && (node.face = "");
        node.style.fontSize && (node.style.fontSize = "");
        node.style.fontFamily && (node.style.fontFamily = "");
        let childNodes = node.childNodes;
        for (let i = 0; i < childNodes.length; i++) {
          this.dealNode(childNodes[i]);
        }
      }
    },
    doClose() {
      this.$emit("close");
    },
    doSave() {
      this.$emit("save", tinymce.get(this.id).getContent());
    },
    startDivide(n) {
      this.isDivideRange = true;
      this.editablePaper ||
        ((this.mouseDownPositionX = n.pageX),
        (this.mouseDownPositionY = n.pageY));
    },
    endDivide(n) {
      if (!this.editablePaper && this.isDivideRange) {
        this.mouseUpPositionX = n.pageX;
        this.mouseUpPositionY = n.pageY;
        if (!(Math.abs(this.mouseUpPositionX - this.mouseDownPositionX) < 1)) {
          var l = this.getHtml();
          if (
            l &&
            l !== undefined &&
            l !== "" &&
            l.trim() !== null &&
            l.trim() !== "" &&
            l !== "null"
          ) {
            this.$emit('divide', l)
          }
        }
      }
      this.isDivideRange = false
    },
    leaveDivide(n) {
      setTimeout(() => {
        this.endDivide(n)
      }, 600);
    },
    getHtml() {
      let range;
      if (window.getSelection || window.document.getSelection)
        try {
          range = window.getSelection().getRangeAt(0);
          let classes = range.commonAncestorContainer.className;
          let parentClasss
          if (range.commonAncestorContainer.offsetParent) {
            parentClasss = range.commonAncestorContainer.offsetParent.className
          }
          if ((classes && classes.includes('qArea')) || (parentClasss && parentClasss.includes('qArea'))) {
            this.$message.warning("划题区域包含已划题，请重新划题！");
            return null;
          } else {
            var n = window.document.createElement("div");
            return n.appendChild(range.cloneContents()), n.innerHTML;
          }
        } catch (n) {
          console.log(n);
        }
      else if (window.document.selection) {
        this.$message.warning("当前浏览器不支持划题");
      }
    }
  },
};
</script>

<style lang="scss">
.editorHtml {
  position: relative;

  .split-mark {
    position: fixed;
    top: 0;
    right: 480px;
    bottom: 0;
    left: 0;
    background: rgba($color: #000000, $alpha: 0.6);
    z-index: 1;
  }

  .paper-html-box {
    position: relative;
    background: #fff;
    z-index: 2;
  }

  .scroll-box {
    position: relative;
    height: calc(100vh - 230px);
    padding-right: 8px;
    overflow-y: scroll;
    overflow-x: hidden;

    &::-webkit-scrollbar-corner {
      width: 0;
    }

    &::-webkit-scrollbar {
      width: 16px;
      height: 16px;
      background: transparent;
    }

    &::-webkit-scrollbar-track {
      background: #fff;
      // border-left: 1px solid rgba(244, 244, 244, 0.14);
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 8px;
      border: 4px solid transparent;
      background-clip: content-box;
      background-color: #ccf0e7;
    }

    // .ps__rail-y {
    //   opacity: 1 !important;

    //   .ps__thumb-y {
    //     background: #ccf0e7;
    //     width: 8px;
    //   }
    // }

    // .ps__rail-y:hover {
    //   opacity: 1 !important;
    //   background: transparent;
    // }
  }

  .no-scroll-box {
    position: relative;
    padding-right: 8px;
  }

  .edit-main {
    position: relative;
    min-height: 500px;
    padding: 0 0 0 8px;

    .question-number {
      position: absolute;
      left: 10px;
      top: 10px;
      color: #0fa784;
    }

    p::after {
      visibility: hidden;
      display: block;
      font-size: 0;
      content: " ";
      clear: both;
      height: 0;
    }
  }

  .tinymce-tool-bar {
    position: absolute;
    left: 0;
    width: 708px;
    height: 36px;
    top: -36px;
    z-index: 2;
  }

  .tinymce-tool-bar-fix {
    .mce-container.mce-panel {
      display: block !important; /* 保持工具栏始终可见 */
    }
  }

  .bg-btn {
    height: 32px;
    line-height: 30px;
    background: #0fa784;
    border: 1px solid #00996b;
    border-radius: 2px;
    color: #fff;
    text-align: center;
    box-sizing: border-box;
    cursor: pointer;
  }

  .cancle-btn {
    position: absolute;
    right: 104px;
    top: -36px;
    z-index: 2;
    background: #ffffff;
    border: 1px solid #00996b;
    color: #00996b;
    width: 88px;
  }

  .save-btn {
    position: absolute;
    right: 0px;
    top: -36px;
    z-index: 2;
    width: 88px;
  }

  @media screen and (max-width: 1660px) {
    .cancle-btn,
    .save-btn {
      top: -72px;
    }
  }

  .editor-tag-list {
    position: absolute;
    top: 0px;
    left: -102px;
    width: 98px;
    min-height: 232px;
    background: #ffffff;
    border: 1px solid #e5e6eb;
    border-radius: 6px;
    padding: 12px 8px 12px 8px;
    z-index: 2;

    h1 {
      color: #1d2129;
      line-height: 18px;
      font-size: 13px;
      text-align: center;
      margin: 0 0 8px 0;

      img {
        width: 14px;
        height: 14px;
        margin-right: 4px;
        vertical-align: text-top;
      }
    }

    hr {
      width: 80px;
      height: 1px;
      background: #E5E6EB;
      margin: 12px auto;
      border: 0px solid #fff;
    }

    span {
      display: block;
      width: 80px;
      height: 28px;
      line-height: 28px;
      text-align: center;
      // background: #f2f3f5;
      border-radius: 4px;
      margin-bottom: 8px;
      font-size: 12px;
      color: #4E5969;
      line-height: 28px;
      cursor: pointer;
      border: 1px solid #E5E6EB;
    }

    @media screen and (max-width: 1560px) {
      span {
        margin-bottom: 4px;
      }
    }

    span:hover {
      border: 1px solid #0fa784;
      color: #0fa784;
    }

    .rule-btn {
      background: #0fa784;
      border: 1px solid #0fa784;
      color: #fff;
      margin-bottom: 0;
      margin-top: 24px;

      i {
        font-size: 14px;
        color: #fff;
        margin-right: 4px;
      }

      &:hover {
        background: #0fa784;
        border: 1px solid #0fa784;
        color: #fff;
      }
    }

    @media screen and (max-width: 1560px) {
      .rule-btn {
        margin-top: 12px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/htmlSplit/components/editorHtml.vue